import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  restoreActionInfo,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveActionStateDescription,
  saveDurationValueAfterActionColorType,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectMultilevelSwitchActionType
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/MultilevelSwitchActions/SelectMultilevelSwitchActionType/SelectMultilevelSwitchActionType'
import SelectMultilevelSwitchActionTypeIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/MultilevelSwitchActions/SelectMultilevelSwitchActionType/SelectMultilevelSwitchActionType'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectMultilevelSwitchActionTypeIOS) : withStyles(SelectMultilevelSwitchActionType)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { stateDescription } = state.scenes.currentSceneCreating.currentAction
  const {
    isChangeActionMode,
    isChangeActionStateMode,
    isEditActionMode,
    initialAction,
  } = state.scenes.currentSceneCreating
  const { actions } = state.scenes.currentSceneConditionsActions
  return {
    isMobile,
    path,
    stateDescription,
    isChangeActionMode,
    isChangeActionStateMode,
    isEditActionMode,
    actions,
    initialAction,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  restoreActionInfo,
  saveActionStateDescription,
  saveActionDelay,
  saveActionDelayDescription,
  saveActionDuration,
  saveActionDurationDescription,
  saveActionDurationValueAfter,
  saveDurationValueAfterActionColorType,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectMultilevelSwitchActionTypeEnhanced = enhance

export default withRouter(SelectMultilevelSwitchActionTypeEnhanced)
